import React from 'react'
import { FieldConfig, useField } from 'formik'
import { Switch } from '@mui/material'

interface FieldSwitchProps extends FieldConfig {}
export function FieldSwitch({ ...props }) {
  const [field, meta] = useField(props.name)

  return (
    <div className="field-container">
      <Switch {...props} {...field} checked={field.value} />
      {!!meta.touched && !!meta.error && <div>{meta.error}</div>}
    </div>
  )
}
